import { render, staticRenderFns } from "./addDept.vue?vue&type=template&id=4577da5a&scoped=true"
import script from "./addDept.vue?vue&type=script&lang=js"
export * from "./addDept.vue?vue&type=script&lang=js"
import style0 from "./addDept.vue?vue&type=style&index=0&id=4577da5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577da5a",
  null
  
)

export default component.exports